import { render, staticRenderFns } from "./LegalParameterVigenciaModal.vue?vue&type=template&id=8f79e2a6"
import script from "./LegalParameterVigenciaModal.vue?vue&type=script&lang=js"
export * from "./LegalParameterVigenciaModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports